<div class="noteSubpage">
  <section role="tablist" class="bm-tabs bm-tabs-lift w-full">
    <button role="tab" class="bm-tab" [class.bm-tab-active]="isSelectedTab('form')" (click)="selectTab('form')">
      Logbuch Eintrag
    </button>
    <button role="tab" class="bm-tab" [class.bm-tab-active]="isSelectedTab('history')" (click)="selectTab('history')">
      Historie
    </button>
    <div class="bm-tab-content bg-base-100 border-t-base-300 pt-3">
      @if (isSelectedTab("form")) {
        <form [formGroup]="noteForm" (submit)="submitNote()">
          <section>
            <div class="font-md font-bold">Abrechnungsrelevante Abzüge / Vorlagen</div>
            <ul class="checklist">
              <li>
                <label
                  ><input type="checkbox" formControlName="special_billing" /> Besonderheiten in der Abrechnung</label
                >
              </li>
              <li>
                <label><input type="checkbox" formControlName="not_on_time" /> Terminuntreue</label>
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="material_faulty" /> falsche / fehlende
                  Materialinformationen</label
                >
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="special_condition" /> Sonderkonditionen (Buchhaltung)</label
                >
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="feedback_incomplete" /> unvollständige Rückmeldung</label
                >
              </li>
              <li>
                <label><input type="checkbox" formControlName="missing_signature" /> fehlende Unterschrift</label>
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="other_problem" (change)="noteTypeChanged()" /> Sonstiges
                  @if (otherProblemChecked()) {
                    <input type="text" formControlName="other_problem_title" />
                  }
                </label>
              </li>
            </ul>
            @if (operation) {
              <select class="selectbox" formControlName="technician_id" (change)="technicianChanged()">
                @for (tech of technicians; track tech) {
                  <option [value]="tech.id">{{ tech.full_name }}</option>
                }
                <option value="-" selected="true">-</option>
              </select>
            }
          </section>
          <section>
            <div class="bm-divider bm-divider-start font-md font-bold">Informationen / Hinweise</div>
            <textarea formControlName="note" class="bm-textarea"></textarea>
          </section>
          <section>
            <div class="bm-divider bm-divider-start font-md font-bold">Quelle</div>
            <div class="flex flex-row gap-2">
              <select formControlName="source_type" class="bm-select flex-1">
                @for (st of sourceTypes; track $index) {
                  <option [value]="st">{{ sourceTypeLabels[st] }}</option>
                }
              </select>
              <input type="text" class="bm-input flex-1" formControlName="source" placeholder="test@kunde.de" />
            </div>
          </section>
          <section>
            <div class="bm-divider bm-divider-start font-md font-bold">Teilen mit</div>
            <ul class="checklist">
              <li>
                <label
                  ><input type="checkbox" formControlName="share_internal" (change)="checkboxChanged()" /> Interne
                  Informationen</label
                >
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="share_customer" (change)="checkboxChanged()" /> Kunde</label
                >
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="share_bookkeeper" (change)="checkboxChanged()" /> Buchhaltung
                  (Sonderk.)</label
                >
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="share_technician" (change)="checkboxChanged()" />
                  Techniker</label
                >
              </li>
              <li>
                <label
                  ><input type="checkbox" formControlName="share_partner" (change)="checkboxChanged()" /> Partner</label
                >
              </li>
            </ul>
          </section>
        </form>
        <div class="flex flex-row justify-end mt-4">
          <button class="bm-btn bm-btn-primary" (click)="submitNote()">Speichern</button>
        </div>
      }
      @if (isSelectedTab("history")) {
        <div class="flex flex-col gap-2">
          <section class="flex flex-row gap-2 items-center">
            <label class="flex-1"> Filter: </label>
            <div class="flex-none bm-join">
              <button
                class="bm-join-item bm-btn bm-bnt-sm bm-indicator"
                [class.bm-btn-primary]="activeFilterBox === 'type'"
                (click)="activateFilterBox('type')"
              >
                nach Art
                @if (filterType.length > 0) {
                  <span class="bm-indicator-item bm-badge bm-badge-xs bm-badge-success">atkiv</span>
                }
              </button>
              <button
                class="bm-join-item bm-btn bm-bnt-sm bm-indicator"
                [class.bm-btn-primary]="activeFilterBox === 'technician'"
                (click)="activateFilterBox('technician')"
              >
                nach Techniker
                @if (filterTechnician.length > 0) {
                  <span class="bm-indicator-item bm-badge bm-badge-xs bm-badge-success">atkiv</span>
                }
              </button>
              <button
                class="bm-join-item bm-btn bm-bnt-sm bm-indicator"
                [class.bm-btn-primary]="activeFilterBox === 'source'"
                (click)="activateFilterBox('source')"
              >
                nach Quelle
                @if (filterSource.length > 0) {
                  <span class="bm-indicator-item bm-badge bm-badge-xs bm-badge-success">atkiv</span>
                }
              </button>
              <button
                class="bm-join-item bm-btn bm-bnt-sm bm-indicator"
                [class.bm-btn-primary]="activeFilterBox === 'destination'"
                (click)="activateFilterBox('destination')"
              >
                nach Empfänger
                @if (filterDestination.length > 0) {
                  <span class="bm-indicator-item bm-badge bm-badge-xs bm-badge-success">atkiv</span>
                }
              </button>
            </div>
          </section>
          <form [formGroup]="filterForm">
            @if (activeFilterBox === "type") {
              <section>
                <div class="bm-divider bm-divider-start font-md font-bold">Filterauswahl: Art</div>
                <ul class="checklist">
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="special_billing" /> Besonderheiten in
                      der Abrechnung</label
                    >
                  </li>
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="not_on_time" /> Terminuntreue</label
                    >
                  </li>
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="material_faulty" /> falsche /
                      fehlende Materialinformationen</label
                    >
                  </li>
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="special_condition" />
                      Sonderkonditionen (Buchhaltung)</label
                    >
                  </li>
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="feedback_incomplete" />
                      unvollständige Rückmeldung</label
                    >
                  </li>
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="missing_signature" /> fehlende
                      Unterschrift</label
                    >
                  </li>
                  <li>
                    <label
                      ><input
                        type="checkbox"
                        class="bm-checkbox"
                        formControlName="other_problem"
                        (change)="noteTypeChanged()"
                      />
                      Sonstiges
                    </label>
                  </li>
                </ul>
                <div class="flex flex-row justify-end bm-join">
                  <button class="bm-join-item bm-btn bm-btn-primary" (click)="setType()">Filter speichern</button>
                  <button class="bm-join-item bm-btn bm-btn-secondary" (click)="resetType()">Filter löschen</button>
                </div>
              </section>
            }
            @if (activeFilterBox === "technician") {
              <section>
                <div class="bm-divider bm-divider-start font-md font-bold">Filterauswahl: Techniker</div>
                <select class="selectbox" formControlName="technician_id" class="bm-select">
                  @for (tech of technicians; track tech) {
                    <option [value]="tech.id">{{ tech.full_name }}</option>
                  }
                </select>
                <div class="flex flex-row justify-end bm-join">
                  <button class="bm-join-item bm-btn bm-btn-primary" (click)="setTechnician()">Filter speichern</button>
                  <button class="bm-join-item bm-btn bm-btn-secondary" (click)="resetTechnician()">
                    Filter löschen
                  </button>
                </div>
              </section>
            }
            @if (activeFilterBox === "source") {
              <section>
                <div class="bm-divider bm-divider-start font-md font-bold">Filterauswahl: Quelle</div>
                <select
                  class="selectboxSmall"
                  class="bm-select"
                  formControlName="source_type"
                  style="margin-right: 10px"
                >
                  @for (st of sourceTypes; track st) {
                    <option [value]="st">{{ sourceTypeLabels[st] }}</option>
                  }
                </select>
                <div class="flex flex-row justify-end bm-join">
                  <button class="bm-join-item bm-btn bm-btn-primary" (click)="setSource()">Filter speichern</button>
                  <button class="bm-join-item bm-btn bm-btn-secondary" (click)="resetSource()">Filter löschen</button>
                </div>
              </section>
            }
            @if (activeFilterBox === "destination") {
              <section>
                <div class="bm-divider bm-divider-start font-md font-bold">Filterauswahl: Empfänger</div>
                <ul class="checklist">
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="share_internal" /> Interne
                      Informationen</label
                    >
                  </li>
                  <li>
                    <label><input type="checkbox" class="bm-checkbox" formControlName="share_customer" /> Kunde</label>
                  </li>
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="share_bookkeeper" /> Buchhaltung
                      (Sonderk.)</label
                    >
                  </li>
                  <li>
                    <label
                      ><input type="checkbox" class="bm-checkbox" formControlName="share_technician" /> Techniker</label
                    >
                  </li>
                  <li>
                    <label><input type="checkbox" class="bm-checkbox" formControlName="share_partner" /> Partner</label>
                  </li>
                </ul>
                <div class="flex flex-row justify-end bm-join">
                  <button class="bm-join-item bm-btn bm-btn-primary" (click)="setDestination()">
                    Filter speichern
                  </button>
                  <button class="bm-join-item bm-btn bm-btn-secondary" (click)="resetDestination()">
                    Filter löschen
                  </button>
                </div>
              </section>
            }
          </form>
        </div>
        <div class="flex flex-col gap-2 mt-4">
          @for (note of notes | ticketNoteFilter: filterParameter; track $index) {
            <div class="noteRow">
              <section [className]="nodeClass(note.special_billing)">Ab</section>
              <section [className]="nodeClass(note.not_on_time)">Ter</section>
              <section [className]="nodeClass(note.material_faulty)">Mat</section>
              <section [className]="nodeClass(note.special_condition)">SK</section>
              <section [className]="nodeClass(note.feedback_incomplete)">Rü</section>
              <section [className]="nodeClass(note.missing_signature)">Unt</section>
              <section [className]="nodeClass(note.other_problem)">S</section>
              <section class="noteTypeText">{{ note.other_problem_title }}</section>
            </div>
            <div class="noteRow">
              <section [innerHTML]="processTicketLinks(note.note)"></section>
            </div>
            <div class="noteRow">
              <section class="noteType">
                <div class="noteRow">
                  <section [className]="nodeClass(note.share_internal)">Intern</section>
                  <section [className]="nodeClass(note.share_partner)">Partner</section>
                  <section [className]="nodeClass(note.share_technician)">Techniker</section>
                  <section [className]="nodeClass(note.share_customer)">Kunde</section>
                  <section [className]="nodeClass(note.share_bookkeeper)">Buchhaltung (Sonderk.)</section>
                </div>
              </section>
              <section class="noteTypeTech">Techniker: {{ note.technician_name ? note.technician_name : "-" }}</section>
              <section class="noteTypeAuthor">
                {{ note.created_by_name }}, {{ note.created_at | date: "dd.MM.yyyy HH:mm:ss" }}
              </section>
            </div>
          }
          @for (note of legacyNotes; track $index) {
            <div class="noteRow">
              <section class="noteTypeText">Aus altem Hawk</section>
            </div>
            <div class="noteRow">
              <section>{{ note.text }}</section>
            </div>
            <div class="noteRow">
              <section class="noteType">
                <div class="noteRow">
                  <section></section>
                </div>
              </section>
              <section class="noteTypeAuthor">
                {{ note.email }}, {{ note.date_created | date: "dd.MM.yyyy HH:mm:ss" }}
              </section>
            </div>
          }
        </div>
      }
    </div>
  </section>
</div>
